import React from "react";
import { IRecipientOfPayment } from "../../interfaces/IRecipientOfPayment";
import { Grid } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";


interface IProps {
    editBank: IRecipientOfPayment;
    setEditBank: Function;
}


export const RecipientOfPaymentEdit:React.FC<IProps> = ({
    editBank,
    setEditBank
}) => {
    return(
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomeTextField
                        attr="recipient"
                        label="Kontoinhaber"
                        object={editBank}
                        setObject={setEditBank}
                        type="string"
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="bic"
                        label="BIC"
                        object={editBank}
                        setObject={setEditBank}
                        type="string"
                        required
                    />
                </Grid>
                <Grid item xs={8}>
                    <CustomeTextField
                        attr="iban"
                        label="IBAN"
                        object={editBank}
                        setObject={setEditBank}
                        type="string"
                        required
                    />
                </Grid>
            </Grid>
        </>
    )
}